import * as SharedRoutes from "@/shared/route-names";

export const Add = "add";
export const Signup = "signup";
export const ManageUser = "manageUser";
export const ProfileInformation = "profileInformation";
export const PayrollInformation = "payrollInformation";
export const EmployeeInformation = "employeeInformation";
export const CensusUpload = "payrollCenususUpload";
export const CensusStatus = "payrollCenususStatus";
export const StateListRouteName = "stateList";
export const PlanDetailInformationRouteName = "planDetailInformation";
export const EarliestInviteDatenRouteName = "earliestInviteDate";
export const Onboarding = "onboarding";
export const PayrollCalendar = "payrollCalendar";
export const PayrollReport = "payrollReport";
export const ManagePayrollRoute = "managePayroll";
export const ContributionDashboard = "payrollDashboard";
export const PartnerNewEmployer = "partnerNewEmployer";
export const ManagePayrollFundingFile = "managePayrollFundingFile";
export const EmployerHome = "employerHome";
export const PartnerHome = "partnerHome";
export const PartnerSettings = "partnerSettings";
export const PartnerUsers = "partnerUsers";
export const PartnerUserAdd = "partnerUserAdd";
export const PartnerReports = "partnerReports";
export const PartnerReportRenderQs = "partnerReportRenderQs";
export const PartnerReportsListQs = "partnerReportsListQs";
export const PartnerSecurity = "partnerSecurity";
export const EmployerReportRenderQs = "employerReportRenderQs";
export const EmployerReportsListQs = "employerReportsListQs";
export const EmployerReports = "employerReports";
export const PartnerBillingReport = "partnerBillingReport";
export const PartnerEmployeeSearch = "partnerEmployeeSearch";
export const PartnerAccountHolderDashboard = "PartnerAccountHolderDashboard";
export const PartnerAccountHolderCashTrx = "partnerAccountHolderCashTrx";
export const PartnerAccountHolderExpenses = "partnerAccountHolderExpenses";
export const PartnerAccountHolderContribution = "PartnerAccountHolderContribution";
export const PartnerAccountHolderInvestment = "PartnerAccountHolderInvestment";
export const PartnerCommunicationsAccountHolder = "PartnerCommunicationsAccountHolder";
export const PartnerCommunicationsEmployer = "PartnerCommunicationsEmployer";
export const PartnerResourceForms = "PartnerResourceForms";
export const EmployerResourceForms = "EmployerResourceForms";
export const Privacy = "privacy";
export const ContributionsFileUpload = "ContributionsFileUpload";
export const PendingContributions = "PendingContributions";
export const EmployerResources = "EmployerResources";
export const EmployerCommunicationsKit = "EmployerCommunicationsKit";
export const EmailHistory = "EmailHistory";
export const LoginHistory = "LoginHistory";
export const PartnerAccountHolderManagement = "AccountManagement";
export const MyProgram = "MyProgram";

// New route names for folders

export { Home } from "@/shared/route-names";
export const Settings = "Settings";
export const Employees = "Employees";
export const Contributions = "Contributions";

export const SettingsCompanyDetails = "SettingsCompanyDetails";
export const SettingsHsaPlanDetails = "SettingsHsaPlanDetails";
export const SettingsPayrollIntegration = "SettingsPayrollIntegration";
export const SettingsAddEmployerUser = "SettingsAddEmployerUser";
export const SettingsManageEmployerUser = "SettingsManageEmployerUser";
export const SettingsSecurity = "Security";
export const SettingsMassTransit = "SettingsMassTransit";
export const FileUploadSettings = "FileUploadSettings";

export const EmployeesInvite = "EmployeesInvite";
export const EmployerCensusUpload = "EmployerCensusUpload";
export const EmployeeIdUpload = "EmployeeIdUpload";

export const ContributionsCalendar = "ContributionsCalendar";
export const ContributionsNextPayroll = "ContributionsNextPayroll";
export const ContributionsHistory = "ContributionsHistory";
export const AchContributions = "AchContributions";

export const UmbInvestmentAccount = "UmbInvestmentAccount";
export const TdaInvestmentAccount = "TdaInvestmentAccount";
export const HsabInvestmentAccount = "HsabInvestmentAccountPage";
export const DrivewealthSellInstrumentConfirmV2 = "DrivewealthSellInstrumentConfirmV2";
export const DrivewealthSellInstrumentV2 = "DrivewealthSellInstrumentV2";
export const BulkLiquidationManagement = "BulkLiquidationManagement";

export const EmployeesRoutes = [
  Employees,
  EmployeesInvite,
  EmployeeIdUpload,
  EmployerCensusUpload
];

export const ContributionsRoutes = [
  Contributions,
  ContributionsCalendar,
  ContributionsNextPayroll,
  ContributionsHistory,
  AchContributions,
  ManagePayrollFundingFile,
  PendingContributions
];

export const SettingsRoutes = [
  SettingsCompanyDetails,
  SettingsHsaPlanDetails,
  SettingsPayrollIntegration,
  SettingsAddEmployerUser,
  SettingsManageEmployerUser,
  SettingsSecurity,
  SettingsMassTransit,
  FileUploadSettings
];

export const PartnerAccountHolderInvestmentRoutes = [
  PartnerAccountHolderInvestment,
  SharedRoutes.DrivewealthInvestmentAccount,
  SharedRoutes.DrivewealthInvestmentAccountV2,
  SharedRoutes.DrivewealthAvailableInvestments,
  SharedRoutes.DrivewealthAvailableInvestmentsV2,
  SharedRoutes.DrivewealthInvestmentActivity,
  SharedRoutes.DrivewealthInvestmentActivityV2,
  SharedRoutes.DrivewealthInvestmentDocuments,
  SharedRoutes.DrivewealthInvestmentDocumentsV2,
  SharedRoutes.DrivewealthInvestmentDayTrades,
  SharedRoutes.DrivewealthInvestmentDayTradesV2,
  SharedRoutes.DrivewealthInvestmentFeesV2,
  SharedRoutes.DrivewealthInvestmentAccountList,
  UmbInvestmentAccount,
  TdaInvestmentAccount,
  SharedRoutes.DrivewealthAccountLiquidation
];